import React, { useState } from "react";

export default function NewGroupChatDetails({ members, onBack, onGroupCreated }) {
  const [groupName, setGroupName] = useState("");
  const [error, setError] = useState("");

  const handleCreateGroup = () => {
    const name = groupName.trim();
    if (!name) {
      setError("Please enter a group name.");
      return;
    }

    const groupId = `group_${Date.now()}`;
    const newGroup = {
      id: groupId,
      name,
      members,
      createdAt: Date.now(),
    };

    const existingGroups = JSON.parse(localStorage.getItem("unlink_groups")) || [];
    localStorage.setItem("unlink_groups", JSON.stringify([...existingGroups, newGroup]));

    onGroupCreated(newGroup);
  };

  return (
    <div
      style={{
        padding: "1rem",
        color: "#fff",
        backgroundColor: "#000",
        height: "100vh",
        boxSizing: "border-box",
        overflowY: "auto",
      }}
    >
      {/* Sticky Header */}
      <div
        style={{
          position: "sticky",
          top: 0,
          zIndex: 10,
          backgroundColor: "#000",
          borderBottom: "1px solid #222",
          paddingBottom: "1rem",
          marginBottom: "1.5rem",
          display: "flex",
          alignItems: "center",
        }}
      >
        <button
          onClick={onBack}
          style={{
            color: "#fff",
            background: "none",
            border: "none",
            fontSize: "1.5rem",
            marginRight: "1rem",
            cursor: "pointer",
          }}
        >
          ←
        </button>
        <h2 style={{ margin: 0 }}>Group Details</h2>
      </div>

      <label style={{ marginBottom: "0.5rem", display: "block" }}>Group Name</label>
      <input
        type="text"
        value={groupName}
        onChange={(e) => setGroupName(e.target.value)}
        placeholder="Enter a group name"
        style={{
          width: "100%",
          padding: "0.5rem",
          marginBottom: "1rem",
          borderRadius: "6px",
          border: "none",
          backgroundColor: "rgb(50 50 50)",
          color: "#4e8cff",
        }}
      />

      {error && <div style={{ color: "#f66", marginBottom: "1rem" }}>{error}</div>}

      <h3 style={{ marginTop: "2rem", marginBottom: "1rem" }}>Members</h3>
      <ul style={{ listStyle: "none", padding: 0 }}>
        {members.map((m) => (
          <li
            key={m.id}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "1rem",
              marginBottom: "0.75rem",
              padding: "0.5rem",
              backgroundColor: "#111",
              borderRadius: "6px",
            }}
          >
            <img
              src="/images/avatar.png"
              alt="avatar"
              width="40"
              height="40"
              style={{ borderRadius: "20px", objectFit: "cover", flexShrink: 0 }}
            />
            <div>
              <div style={{ color: "#4e8cff", fontWeight: "bold" }}>{m.name}</div>
              <div style={{ fontSize: "0.85rem", color: "#aaa" }}>{m.id}</div>
            </div>
          </li>
        ))}
      </ul>

      <button
        onClick={handleCreateGroup}
        style={{
          marginTop: "2rem",
          padding: "0.75rem 1.25rem",
          fontSize: "1rem",
          backgroundColor: "#4e8cff",
          color: "white",
          border: "none",
          borderRadius: "6px",
          cursor: "pointer",
          width: "100%",
        }}
      >
        Create Group
      </button>
    </div>
  );
}